// @flow
import React, { Component } from 'react';
import { isEqual } from 'lodash';
import theme from '../../../theme-config';
import { ListViewRow } from '../../common';
import SubscriptionChangeDetails from '../SubscriptionChangeDetails';
import PaymentMeanChangeDetails from '../PaymentMeanChangeDetails';
import { getSubtitle, getTitle } from './lib/titleAndSubtitleService';

class TimelineListViewRow extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return !isEqual(this.props, nextProps);
  }

  onToggle = () => this.props.onToggle(this.props.ouid);

  render() {
    const { type, title, credit, parameters, subtitle, phoneLine, folded, timestamp, amount, detail } = this.props;
    const itemTheme = theme.timelineItems[type] || {
      color: theme.secondaryColor,
      icon: 'info',
      reverse: false,
    };

    const Rowtitle = getTitle(type, title, parameters);
    const rowSubtitle = getSubtitle(subtitle, type, parameters, phoneLine);
    const isSubscriptionChange = (credit || detail) && (type === 'TOPUP_OK' || type === 'CHANGEPLAN_OK');
    const isRoamLikeHome =
      (type === 'TOPUP_OK' && parameters && parameters.hasOwnProperty('RLH_AMOUNT')) ||
      (parameters && parameters.hasOwnProperty('RLH2_AMOUNT'));

    const isGoodwillMulticredit =
      type === 'GOODWILL_CREDIT_OK' &&
      credit &&
      credit.filter(goodwillCredit => Number(goodwillCredit.value) > 0).length > 1;

    const hasSubscriptionDetails = isSubscriptionChange || isRoamLikeHome || isGoodwillMulticredit;
    const isPaymentMeanChange = type === 'PAYMENT_MEAN_REGISTRATION' || type === 'PAYMENT_MEAN_PATCHED';

    return (
      <ListViewRow
        color={itemTheme.color}
        folded={folded}
        iconName={itemTheme.icon}
        onToggle={this.onToggle}
        reverseIcon={itemTheme.reverse}
        subtitle={rowSubtitle}
        timestamp={timestamp}
        title={Rowtitle}
      >
        {hasSubscriptionDetails && (
          <SubscriptionChangeDetails
            amount={amount}
            credit={credit}
            detail={detail}
            type={type}
            parameters={parameters}
          />
        )}
        {isPaymentMeanChange && parameters?.paymentMean && (
          <PaymentMeanChangeDetails
            type={parameters?.paymentMean.type}
            characteristics={parameters?.paymentMean.characteristics}
          />
        )}
      </ListViewRow>
    );
  }
}

export type Props = {
  ouid?: string,
  timestamp: number,
  type: string,
  title?: string,
  subtitle?: string | null,
  amount?: string,
  credit?: Array<Object>,
  detail?: Array<Object>,
  folded?: boolean,
  phoneLine?: string,
  onToggle: Function,
  parameters?: Object,
};

export default TimelineListViewRow;
